<template>
  <div v-if="loadComponent">
    <v-row>
      <v-col cols="12" xs="12" sm="12" md="12" class="py-0 my-0">
        <v-text-field
          label="Subject"
          class="py-0 my-0"
          v-model="emailFormat.subject"
        ></v-text-field>
      </v-col>
    </v-row>
    <quill-editor
      :options="editorOption"
      v-model="emailFormat.message"
    ></quill-editor>
    <v-row>
      <v-col cols="12" xs="12" sm="12" md="12" class="py-0 my-0">
        <v-checkbox
          label="Is Active"
          v-model="emailFormat.isActive"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
      <v-col cols="12" xs="12" sm="12" md="12">
        <v-btn
          color="success"
          :loading="isSaving"
          @click.stop="save"
          v-if="userAccess.update >= 1 || userAccess.add >= 1"
          >Save</v-btn
        >
      </v-col>
      <v-col>
        <v-card>
          <v-container>
            <p>
              These are the following fields that you can use for the Email. To
              use these field. Kindly Input and use the curly brackets eg.
              <b>{ApplicantName}</b>
            </p>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Field Name</th>
                    <th class="text-left">Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in items" :key="item.field">
                    <td style="width: 200px;">{{ item.field }}</td>
                    <td>{{ item.value }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
const API_ENDPOINT = "/api/emailFormat";
import isEmpty from "lodash/isEmpty";
import userAccessMixin from "../../../../mixins/userAccessMixin";
export default {
  components: {
    quillEditor
  },
  mixins: [userAccessMixin],
  data: () => ({
    content: "",
    editorOption: {
      /* quill options */
    },
    isSaving: false,
    items: [
      {
        field: "EmpCode",
        value: "{EmpCode}"
      },
      {
        field: "Employee Name",
        value: "{Employee Name}"
      },
      {
        field: "Approver Name",
        value: "{Approver Name}"
      },
      {
        field: "Transaction No",
        value: "{Transaction No}"
      },
      {
        field: "Remarks",
        value: "{Remarks}"
      },
      {
        field: "Effectivity Date",
        value: "{Effectivity Date}"
      },
      {
        field: "Movement Type",
        value: "{Movement Type}"
      }
    ],
    transType: "PME",
    emailFormat: {}
  }),
  created() {
    this.getEmailFormat(this.transType);

    this.getUserAccessRights("EMAILFRMT");
  },
  methods: {
    getEmailFormat(transType) {
      this.$axios
        .get(`${API_ENDPOINT}/${transType}`)
        .then(({ data }) => {
          if (!isEmpty(data)) this.emailFormat = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    save() {
      this.isSaving = true;
      this.emailFormat.transType = this.transType;
      this.$axios
        .post(`${API_ENDPOINT}`, this.emailFormat)
        .then(({ data }) => {
          this.$toast.success(data.message);
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    }
  }
};
</script>